var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-internship",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-internship:not(.animated) .animable {opacity: 0;}svg#freepik_stories-internship.animated #freepik--background-simple--inject-33 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-internship.animated #freepik--Calendar--inject-33 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-internship.animated #freepik--Clock--inject-33 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-internship.animated #freepik--Picture--inject-33 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-internship.animated #freepik--Plant--inject-33 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-33",
    className: "animable animator-active",
    style: {
      transformOrigin: "384.452px 259.057px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.92,229.15S591,118.75,501.81,76.43,304.93,43.32,252.49,90.23s-38.64,79.12-121.43,162.84-67.16,193.19,69,210.67,138-16.56,252.08-9.2S660,471.1,683,405.78,649.92,229.15,649.92,229.15Z",
    style: {
      fill: "rgb(44, 157, 202)",
      transformOrigin: "384.452px 259.057px"
    },
    id: "ely5bjrxzbqgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj4ijsugvcis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.92,229.15S591,118.75,501.81,76.43,304.93,43.32,252.49,90.23s-38.64,79.12-121.43,162.84-67.16,193.19,69,210.67,138-16.56,252.08-9.2S660,471.1,683,405.78,649.92,229.15,649.92,229.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "384.452px 259.057px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-33",
    className: "animable",
    style: {
      transformOrigin: "642.35px 302.68px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "els81gbbi6ni"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "642.35px 302.68px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.88,
    y: 270.2,
    width: 80.94,
    height: 74.26,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "642.35px 307.33px"
    },
    id: "el9n7nc09hxfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.58,
    y: 300.45,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "611.35px 304.22px"
    },
    id: "eln869ow9ibc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.91,
    y: 300.45,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "621.68px 304.22px"
    },
    id: "elx29xv9vooy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.25,
    y: 300.45,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "632.02px 304.22px"
    },
    id: "elo01rl0emngn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.58,
    y: 300.45,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "642.35px 304.22px"
    },
    id: "elc4rx2de6qua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.91,
    y: 300.45,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "652.68px 304.22px"
    },
    id: "el3wqhhxebiba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 300.45,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "663.02px 304.22px"
    },
    id: "eleztlwk4gror",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.58,
    y: 300.45,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "673.35px 304.22px"
    },
    id: "elyb91b07b0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.58,
    y: 313,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "611.35px 316.77px"
    },
    id: "eltfl83emf6mm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.91,
    y: 313,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "621.68px 316.77px"
    },
    id: "elmdgfaxsmj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.25,
    y: 313,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "632.02px 316.77px"
    },
    id: "el1ovhfmbi1ba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.58,
    y: 313,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "642.35px 316.77px"
    },
    id: "elt8ejlnimelb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.91,
    y: 313,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "652.68px 316.77px"
    },
    id: "el20irkez1ay0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 313,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "663.02px 316.77px"
    },
    id: "elm63kvk0iota",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.58,
    y: 313,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "673.35px 316.77px"
    },
    id: "elrqii82idxt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.58,
    y: 325.54,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "611.35px 329.31px"
    },
    id: "elzg87ml3eze9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.91,
    y: 325.54,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "621.68px 329.31px"
    },
    id: "elsx77xys96k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.25,
    y: 325.54,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "632.02px 329.31px"
    },
    id: "elp1p6cbr4x69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.58,
    y: 325.54,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "642.35px 329.31px"
    },
    id: "eljlpky58zuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.91,
    y: 325.54,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "652.68px 329.31px"
    },
    id: "el6uwmimoxvqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 325.54,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "663.02px 329.31px"
    },
    id: "elilmd95rhell",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.58,
    y: 325.54,
    width: 7.54,
    height: 7.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "673.35px 329.31px"
    },
    id: "elkti16x3i37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.75,
    y: 260.9,
    width: 4.94,
    height: 12.92,
    id: "elw7uns2m5u8",
    className: "animable",
    style: {
      transformOrigin: "618.22px 267.36px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.88,
    y: 260.9,
    width: 4.94,
    height: 12.92,
    id: "el681356xcz2k",
    className: "animable",
    style: {
      transformOrigin: "642.35px 267.36px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.01,
    y: 260.9,
    width: 4.94,
    height: 12.92,
    id: "el3f0dyzbvzex",
    className: "animable",
    style: {
      transformOrigin: "666.48px 267.36px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.51,
    y: 282.56,
    width: 69.16,
    height: 12.54,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "643.09px 288.83px"
    },
    id: "el121d8ozcfjwh",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-33",
    className: "animable",
    style: {
      transformOrigin: "563.68px 119.75px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elz1nps6nn0zq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "563.68px 119.75px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elxuw3as5iu9a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 563.68,
    cy: 119.75,
    r: 41.39,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "563.68px 119.75px",
      transform: "rotate(-45deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0ac8x9fmy0hk"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 563.68,
    cy: 119.75,
    r: 35.11,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "563.68px 119.75px",
      transform: "rotate(-45deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.06,119.75a3.39,3.39,0,1,1-3.38-3.39A3.38,3.38,0,0,1,567.06,119.75Z",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "563.67px 119.75px"
    },
    id: "el3p6lnqsvyt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 561.13,
    y1: 122.4,
    x2: 550.5,
    y2: 131.59,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "555.815px 126.995px"
    },
    id: "eln7lnkj6f02g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 567.06,
    y1: 119.75,
    x2: 594.44,
    y2: 119.75,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "580.75px 119.75px"
    },
    id: "elowqf6xqxalp",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-33",
    className: "animable",
    style: {
      transformOrigin: "316.14px 226.285px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elm62821vudal"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "316.14px 226.285px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.53,391.57h-114V61h114ZM373.16,61h-114V391.57h114ZM491.8,61h-114V391.57H491.8Z",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "316.165px 226.285px"
    },
    id: "elm5rsnx6bhx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,149.27c4,1,13.81-4.22,33.66-50.53A207.85,207.85,0,0,1,194.73,61",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "167.61px 105.188px"
    },
    id: "el9viq4mp6yz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.76,247.76c6.73,8.52,14.08,18.74,22.14,31.27a506.26,506.26,0,0,1,54.24,112.54",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "415.95px 319.665px"
    },
    id: "el3cghu4l5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.15,61c-4.93,19.68-7.55,47.21-.31,81.6,12.91,61.37,30.09,54.59,67.33,99.46",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "337.268px 151.53px"
    },
    id: "el1atlidsqv1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.48,277.79c7-11,14.1-26,20.34-46.58,23.51-77.6,80-109.74,80-37.62s-35.13,110.08-36.06,159.9a105.12,105.12,0,0,0,5.94,38.08",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "190.65px 272.432px"
    },
    id: "el9nwkm29ndrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3,391.57c-11.72-53.28-14.52-109.75.92-114.9,16.13-5.37,31.89,68.18,40.2,114.9",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "340.991px 333.981px"
    },
    id: "ell934drazd6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.17,61c-25.62,52.88-67.92,148.31-40.76,150.58,21.64,1.8,64.55-47,97.39-89.16",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "438.722px 136.314px"
    },
    id: "elftfnf9ffam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx906ayx291"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 340.32,
    cy: 103.44,
    r: 24.3,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "340.32px 103.44px",
      transform: "rotate(-76.86deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M450.06,152.82a5.49,5.49,0,1,1-5.49-5.48A5.49,5.49,0,0,1,450.06,152.82Z",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "444.57px 152.83px"
    },
    id: "ele4qftq2mwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.46,
    cy: 289.6,
    r: 9.01,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "178.46px 289.6px"
    },
    id: "elgd9cqgl2obd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.68,
    cy: 89.73,
    r: 5.88,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "206.68px 89.73px"
    },
    id: "ellicmzxbl48e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7kzutdfcm1w"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 286.24,
    cy: 223.37,
    r: 9.41,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "286.24px 223.37px",
      transform: "rotate(-22.64deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 448.89,
    cy: 284.9,
    r: 21.56,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "448.89px 284.9px"
    },
    id: "elohum87yfoo",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-33",
    className: "animable",
    style: {
      transformOrigin: "560.88px 229.095px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.4,188.63h52.94A11.64,11.64,0,0,1,599,200.27v40.17a11.64,11.64,0,0,1-11.64,11.64H543.59l-20,17.48L533.2,252a11.63,11.63,0,0,1-10.44-11.57V200.27A11.64,11.64,0,0,1,534.4,188.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "560.88px 229.095px"
    },
    id: "elbr4ygvnt1yv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.25,231v-7.82a37.29,37.29,0,0,0,5.07-4.88,22.56,22.56,0,0,0,3.58-5.59,15.34,15.34,0,0,0,1.31-6.26,5.66,5.66,0,0,0-1-3.57,3.39,3.39,0,0,0-2.84-1.19,3.53,3.53,0,0,0-2.62,1,3.58,3.58,0,0,0-1,2.63A6.25,6.25,0,0,0,557,207c.15.49.3,1,.46,1.59l-8.36,1.89a22.1,22.1,0,0,1-.68-2.66,14.67,14.67,0,0,1-.24-2.65,10.92,10.92,0,0,1,3.21-8.34q3.2-3,9.19-3t9.4,3.24q3.3,3.22,3.3,9.22a19.48,19.48,0,0,1-1.28,7.08,22.35,22.35,0,0,1-3.7,6.2,36.84,36.84,0,0,1-5.71,5.47v6Zm-.3,12.89V235h9v8.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "560.722px 218.86px"
    },
    id: "elah73aw7yi6j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-33",
    className: "animable",
    style: {
      transformOrigin: "242.75px 151.405px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.7,110.94H206.81a11.64,11.64,0,0,0-11.64,11.64v40.17a11.64,11.64,0,0,0,11.64,11.64h62.71l20,17.48-9.63-17.54a11.65,11.65,0,0,0,10.44-11.58V122.58A11.64,11.64,0,0,0,278.7,110.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "242.75px 151.405px"
    },
    id: "elt3r2hwmpc2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.51,144a4.53,4.53,0,1,0-4.53,4.53A4.53,4.53,0,0,0,228.51,144Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "223.98px 144px"
    },
    id: "elsisdy3ubuyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.29,144a4.53,4.53,0,1,0-4.53,4.53A4.53,4.53,0,0,0,247.29,144Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "242.76px 144px"
    },
    id: "elo86qfk3lphe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.06,144a4.53,4.53,0,1,0-4.53,4.53A4.53,4.53,0,0,0,266.06,144Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "261.53px 144px"
    },
    id: "elzi5cfdasyl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-33",
    className: "animable",
    style: {
      transformOrigin: "106.82px 316.957px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 79.77,
    y1: 272.26,
    x2: 96,
    y2: 427.76,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "87.885px 350.01px"
    },
    id: "elbda6v0dhl9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.67,
    y1: 424.89,
    x2: 87.41,
    y2: 416.2,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "91.54px 420.545px"
    },
    id: "elixl6qa8ophb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,419a10.15,10.15,0,0,0-3.57-7.61c-2.3-2.06-14.43-7.16-15.58-2.89C69.73,413.18,82.14,422.31,90.13,419Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "80.5112px 413.276px"
    },
    id: "elx7hzqp4ihbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.13,
    y1: 419.04,
    x2: 78.59,
    y2: 411.85,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "84.36px 415.445px"
    },
    id: "elfkd9pk5j1lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.06,
    y1: 370.88,
    x2: 81.91,
    y2: 363.54,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "85.985px 367.21px"
    },
    id: "el8o26aotx37w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.64,366.39a10.19,10.19,0,0,0-3.58-7.62c-2.3-2.06-14.43-7.16-15.58-2.89C64.23,360.53,76.64,369.65,84.64,366.39Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "75.0162px 360.652px"
    },
    id: "el3x7mvcfqqve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.64,
    y1: 366.39,
    x2: 73.09,
    y2: 359.19,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "78.865px 362.79px"
    },
    id: "elp1rh8yn8m7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.33,
    y1: 393.83,
    x2: 84.16,
    y2: 385.12,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "88.245px 389.475px"
    },
    id: "elcn1xr3ilqp8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.89,388a10.15,10.15,0,0,0-3.57-7.61c-2.31-2.06-14.43-7.16-15.58-2.89C66.48,382.11,78.9,391.23,86.89,388Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "77.2706px 382.261px"
    },
    id: "elzmt2qfdnxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.89,
    y1: 387.96,
    x2: 75.34,
    y2: 380.77,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "81.115px 384.365px"
    },
    id: "elsy3fjj9wam8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.43,
    y1: 336.83,
    x2: 78.25,
    y2: 328.49,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "82.34px 332.66px"
    },
    id: "el877xc8y8yx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,331.33a10.15,10.15,0,0,0-3.57-7.61c-2.31-2.06-14.43-7.16-15.59-2.89C60.57,325.48,73,334.6,81,331.33Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "71.3749px 325.599px"
    },
    id: "ellfbfjl6uryl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.98,
    y1: 331.33,
    x2: 69.43,
    y2: 324.14,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "75.205px 327.735px"
    },
    id: "elaxemn25aik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.49,
    y1: 299.34,
    x2: 74.58,
    y2: 293.29,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "78.535px 296.315px"
    },
    id: "elzmb57x89ip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3,296.13a10.16,10.16,0,0,0-3.57-7.62c-2.3-2.06-14.43-7.16-15.58-2.89C56.9,290.27,69.31,299.39,77.3,296.13Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "67.6812px 290.392px"
    },
    id: "el3qp6fdh3sbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.3,
    y1: 296.13,
    x2: 65.76,
    y2: 288.93,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "71.53px 292.53px"
    },
    id: "el4f4z7ltfgi8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.87,
    y1: 412.91,
    x2: 101.7,
    y2: 401.78,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.285px 407.345px"
    },
    id: "elgyd4hgt1c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.62,405.13a10.16,10.16,0,0,1,1.92-8.19c1.83-2.49,12.64-10,14.65-6C118.37,395.18,108.11,406.67,99.62,405.13Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "107.956px 397.53px"
    },
    id: "el5thkh4wtxbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.62,
    y1: 405.13,
    x2: 107.74,
    y2: 397.51,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "103.68px 401.32px"
    },
    id: "el7rl0yfby1uw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.95,
    y1: 356.13,
    x2: 95.77,
    y2: 345,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "92.36px 350.565px"
    },
    id: "el8aqmazeewv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.69,348.34a10.16,10.16,0,0,1,1.92-8.19c1.83-2.48,10.29-8.72,12.3-4.78C110.09,339.66,102.19,349.89,93.69,348.34Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "100.885px 341.298px"
    },
    id: "elh73bfqianzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.69,
    y1: 348.34,
    x2: 104.09,
    y2: 338.41,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.89px 343.375px"
    },
    id: "elgadqkiyzj4h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.34,
    y1: 331.18,
    x2: 93.17,
    y2: 320.05,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "89.755px 325.615px"
    },
    id: "el0sjgj0dg1oa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.09,323.39A10.16,10.16,0,0,1,93,315.2c1.83-2.49,12.64-10,14.65-6C109.84,313.44,99.58,324.93,91.09,323.39Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "99.4209px 315.79px"
    },
    id: "elzocla2hp69j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.09,
    y1: 323.39,
    x2: 101.48,
    y2: 313.45,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "96.285px 318.42px"
    },
    id: "ell45p1436b3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.52,
    y1: 294.59,
    x2: 89.35,
    y2: 283.46,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "85.935px 289.025px"
    },
    id: "elkyb2sj4w35c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.27,286.8a10.14,10.14,0,0,1,1.92-8.18c1.83-2.49,12.64-10,14.65-6.05C106,276.86,95.76,288.35,87.27,286.8Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "95.6034px 279.193px"
    },
    id: "el9cvuhfdoegs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.27,
    y1: 286.8,
    x2: 97.66,
    y2: 276.87,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "92.465px 281.835px"
    },
    id: "el7g60kbjer6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.61,271.2A10.16,10.16,0,0,1,81.53,263c1.83-2.49,12.64-10,14.65-6C98.36,261.26,88.1,272.75,79.61,271.2Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "87.9448px 263.596px"
    },
    id: "elk3titm0084",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.61,
    y1: 271.2,
    x2: 90,
    y2: 261.27,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "84.805px 266.235px"
    },
    id: "el4eklx32bhfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.21,271.63a10.14,10.14,0,0,1-7.94-2.77c-2.29-2.08-8.61-13.62-4.48-15.2C72.28,251.93,82.63,263.34,80.21,271.63Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "73.4967px 262.579px"
    },
    id: "elm4gyu20mr7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.21,
    y1: 271.63,
    x2: 71.42,
    y2: 260.25,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "75.815px 265.94px"
    },
    id: "el4gjb6m8xkd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.43,
    y1: 221.12,
    x2: 109.43,
    y2: 428.17,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "109.43px 324.645px"
    },
    id: "el6kyjwld2r6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: 298.39,
    x2: 118.43,
    y2: 427.52,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "125.215px 362.955px"
    },
    id: "el5sugw8p5qxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.03,
    y1: 395.19,
    x2: 115.27,
    y2: 389.55,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "118.65px 392.37px"
    },
    id: "elsl9w2vx5qe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.38,391.5a10.19,10.19,0,0,0-1.93-8.19c-1.83-2.48-12.65-10-14.65-6C98.62,381.57,108.88,393.05,117.38,391.5Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "109.037px 383.901px"
    },
    id: "el2dlriqi049s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.38,
    y1: 391.5,
    x2: 107.56,
    y2: 382.08,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "112.47px 386.79px"
    },
    id: "eltqwq6na4bn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.51,
    y1: 419.04,
    x2: 113.05,
    y2: 409.74,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "116.28px 414.39px"
    },
    id: "eln546gxzpc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,413.08a10.19,10.19,0,0,0-1.93-8.19c-1.83-2.48-12.65-10-14.65-6C96.38,403.15,106.64,414.63,115.14,413.08Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.797px 405.481px"
    },
    id: "elvisjh66axop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.14,
    y1: 413.08,
    x2: 105.32,
    y2: 403.66,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "110.23px 408.37px"
    },
    id: "el8m3ss9ucucb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.45,
    y1: 360.62,
    x2: 118.93,
    y2: 353.1,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "122.19px 356.86px"
    },
    id: "el3moarjdn6ub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,356.45a10.19,10.19,0,0,0-1.93-8.19c-1.83-2.49-12.65-10-14.66-6C102.25,346.51,112.52,358,121,356.45Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "112.655px 348.851px"
    },
    id: "eld175c1s7jfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.02,
    y1: 356.45,
    x2: 111.2,
    y2: 347.03,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "116.11px 351.74px"
    },
    id: "els8m9xive1jf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.88,
    y1: 327.67,
    x2: 122.59,
    y2: 317.9,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "125.735px 322.785px"
    },
    id: "elc2aws8ol81v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67,321.24a10.19,10.19,0,0,0-1.93-8.19c-1.83-2.49-12.65-10-14.65-6C105.91,311.3,116.17,322.79,124.67,321.24Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "116.327px 313.641px"
    },
    id: "el9wnhwffr7ik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.67,
    y1: 321.24,
    x2: 114.85,
    y2: 311.82,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "119.76px 316.53px"
    },
    id: "elyrvwanwtb3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.71,
    y1: 382.35,
    x2: 132.68,
    y2: 372.87,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "128.195px 377.61px"
    },
    id: "el3iy23b9y9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,375.71a10.16,10.16,0,0,1,3.57-7.62c2.3-2.06,14.43-7.17,15.58-2.9C150.35,369.84,138,379,130,375.71Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "139.616px 369.972px"
    },
    id: "elvoecrjgjfci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.95,
    y1: 375.71,
    x2: 142.17,
    y2: 368.13,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "136.06px 371.92px"
    },
    id: "elnutw1gnvu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.3,
    y1: 357.4,
    x2: 135.27,
    y2: 347.91,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "130.785px 352.655px"
    },
    id: "elefl34norxde",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.54,350.75a10.15,10.15,0,0,1,3.57-7.61c2.3-2.06,14.43-7.17,15.58-2.9C152.94,344.88,140.54,354,132.54,350.75Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "142.159px 345.011px"
    },
    id: "el1lqsxom2olx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.54,
    y1: 350.75,
    x2: 144.76,
    y2: 343.17,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "138.65px 346.96px"
    },
    id: "elnzcacajlpk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.99,
    y1: 318.94,
    x2: 139.06,
    y2: 311.32,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "134.525px 315.13px"
    },
    id: "el4to25ptgyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.34,314.17a10.16,10.16,0,0,1,3.57-7.62c2.3-2.06,14.42-7.17,15.58-2.9C156.74,308.3,144.33,317.43,136.34,314.17Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "145.959px 308.427px"
    },
    id: "elsih7vtr04w8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.34,
    y1: 314.17,
    x2: 148.56,
    y2: 306.58,
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "142.45px 310.375px"
    },
    id: "ely96t0b6jxsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,297.32a10.17,10.17,0,0,1,3.57-7.62c2.3-2.06,14.43-7.16,15.58-2.89C152.45,291.45,140.05,300.58,132.05,297.32Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "141.669px 291.581px"
    },
    id: "elxg3gmldqmr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.05,
    y1: 297.32,
    x2: 144.27,
    y2: 289.74,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "138.16px 293.53px"
    },
    id: "elv5qofm74va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.55,297.86a10.18,10.18,0,0,1-7.2-4.34c-1.8-2.51-5.61-15.1-1.24-15.8C128.86,277,136.63,290.25,132.55,297.86Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "127.892px 287.776px"
    },
    id: "elvyhduwivfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.55,
    y1: 297.86,
    x2: 126.29,
    y2: 284.92,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "129.42px 291.39px"
    },
    id: "eln4yvht31wx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.11,
    y1: 424.55,
    x2: 101.68,
    y2: 414.63,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "105.395px 419.59px"
    },
    id: "elacp36xxt5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,417.74a10.18,10.18,0,0,0-2.76-7.95c-2.08-2.28-13.61-8.62-15.2-4.49C84.41,409.79,95.81,420.16,104.1,417.74Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "95.0535px 411.018px"
    },
    id: "eli37rdw9joq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.1,
    y1: 417.74,
    x2: 93.36,
    y2: 409.38,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.73px 413.56px"
    },
    id: "elgo688mny14q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.37,
    y1: 376.69,
    x2: 101.68,
    y2: 369.54,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "105.525px 373.115px"
    },
    id: "eljr5j7j1zcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,372.64a10.17,10.17,0,0,0-2.76-7.94c-2.08-2.29-13.61-8.62-15.2-4.49C84.41,364.7,95.81,375.06,104.1,372.64Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "95.0533px 365.922px"
    },
    id: "elmi9v2kq96zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.1,
    y1: 372.64,
    x2: 93.36,
    y2: 364.29,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.73px 368.465px"
    },
    id: "elvhv4sjahh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.63,
    y1: 326.96,
    x2: 101.68,
    y2: 316.59,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "105.655px 321.775px"
    },
    id: "elnv4croiddsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,319.7a10.17,10.17,0,0,0-2.76-7.94c-2.08-2.29-13.61-8.62-15.2-4.49C84.41,311.76,95.81,322.12,104.1,319.7Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "95.0533px 312.982px"
    },
    id: "el3ysg04n1wlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.1,
    y1: 319.7,
    x2: 93.36,
    y2: 311.35,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.73px 315.525px"
    },
    id: "el656lu0n7qqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.11,
    y1: 288.04,
    x2: 101.68,
    y2: 281.35,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "105.395px 284.695px"
    },
    id: "el7s4va5udql4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,284.46a10.16,10.16,0,0,0-2.76-7.94c-2.08-2.29-13.61-8.62-15.2-4.49C84.41,276.52,95.81,286.88,104.1,284.46Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "95.0535px 277.742px"
    },
    id: "el4hm71i99fgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.1,
    y1: 284.46,
    x2: 93.36,
    y2: 276.11,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.73px 280.285px"
    },
    id: "elwo4r4wor3xq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.54,
    y1: 252.78,
    x2: 101.83,
    y2: 247.14,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "105.685px 249.96px"
    },
    id: "eloh4qufqy7rf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,249.06a10.17,10.17,0,0,0-2.76-7.94c-2.08-2.29-13.61-8.62-15.2-4.49C84.41,241.12,95.81,251.48,104.1,249.06Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "95.0533px 242.342px"
    },
    id: "eltqvr97n00xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.1,
    y1: 249.06,
    x2: 93.36,
    y2: 240.71,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.73px 244.885px"
    },
    id: "eltq6j91qhlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.45,
    y1: 367.04,
    x2: 117.39,
    y2: 356.68,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "113.42px 361.86px"
    },
    id: "ela2diclo9qje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,359.79a10.16,10.16,0,0,1,2.76-7.94c2.08-2.29,13.61-8.62,15.2-4.5C134.66,351.85,123.27,362.21,115,359.79Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.044px 353.07px"
    },
    id: "elqq6moofgx3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.98,
    y1: 359.79,
    x2: 126.35,
    y2: 350.99,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "120.665px 355.39px"
    },
    id: "elb0ju6yv5n5w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.45,
    y1: 331.65,
    x2: 117.39,
    y2: 321.28,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "113.42px 326.465px"
    },
    id: "elpryavc85t4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,324.39a10.17,10.17,0,0,1,2.76-7.94c2.08-2.29,13.61-8.62,15.2-4.49C134.66,316.45,123.27,326.81,115,324.39Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.044px 317.672px"
    },
    id: "el715plvs5d8u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.98,
    y1: 324.39,
    x2: 126.35,
    y2: 315.59,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "120.665px 319.99px"
    },
    id: "eljx1jxge7y3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.45,
    y1: 284.86,
    x2: 117.39,
    y2: 274.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "113.42px 279.68px"
    },
    id: "ele96t440heqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,277.61a10.18,10.18,0,0,1,2.76-7.95c2.08-2.28,13.61-8.62,15.2-4.49C134.66,269.66,123.27,280,115,277.61Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.044px 270.884px"
    },
    id: "el2efeq9ivrpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.98,
    y1: 277.61,
    x2: 126.35,
    y2: 268.8,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "120.665px 273.205px"
    },
    id: "elj1p4w7ea1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.79,
    y1: 244.48,
    x2: 117.58,
    y2: 238.41,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "113.685px 241.445px"
    },
    id: "elcseq5i2cbwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,240.82a10.17,10.17,0,0,1,2.76-7.94c2.08-2.29,13.61-8.62,15.2-4.49C134.66,232.88,123.27,243.24,115,240.82Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.044px 234.102px"
    },
    id: "elqt0v2w6l28r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.98,
    y1: 240.82,
    x2: 126.35,
    y2: 232.02,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "120.665px 236.42px"
    },
    id: "el274v23fziz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,224.51a10.15,10.15,0,0,1,2.77-7.94c2.08-2.29,13.61-8.62,15.2-4.49C128.66,216.57,117.26,226.93,109,224.51Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "118.048px 217.792px"
    },
    id: "eloxyekfmum1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.97,
    y1: 224.51,
    x2: 120.35,
    y2: 215.71,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "114.66px 220.11px"
    },
    id: "el7nbs5rxeo7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.53,225a10.18,10.18,0,0,1-7.61-3.58c-2.06-2.31-7.14-14.44-2.87-15.59C103.69,204.59,112.8,217,109.53,225Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "103.807px 215.372px"
    },
    id: "el0g3gmqak644",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.53,
    y1: 225,
    x2: 101.97,
    y2: 212.77,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "105.75px 218.885px"
    },
    id: "ellq4gsfm1xah",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character1--inject-33",
    className: "animable",
    style: {
      transformOrigin: "339.805px 278.662px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.14,428.17l-15.49-62.73L251,366.29c-6.25,10.53-19.6,46.19-25.36,61.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "305.89px 396.805px"
    },
    id: "el2d2xvghsnyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.21,334.26l9.16,1.57s18.84-1.31,20.41-1.31,12.83,9.16,12.83,9.16l-19.11-.26s-13.6,3.92-18.31,3.92-10.47-5.49-10.47-5.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "481.665px 340.8px"
    },
    id: "elas7kt9rvha7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.88,340.28s17,.52,18.84.26,5.76-2.62,5.76-.26-2.62,1.57-5,3.14a24.11,24.11,0,0,1-4.44,2.35s-3.67,1.05-6.81,1.57-3.92.26-7.06,0a11,11,0,0,1-5.24-1.83",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "477.205px 343.44px"
    },
    id: "elzz8yfh2ws2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.72,279.11l-13-26.92s.55-30.19,0-34.58-1.09-8.51-9.6-11-58.74,1.64-58.74,1.64-13.38,1.32-25.22,3.41-38,2.24-39.34,6.36-7.5,98-7.5,98l-24.56,55.26s23,18.94,70.81,16.19S377.1,370,377.1,370l-13.45-48s22.23-19.76,22.78-25.8.82-10.71.82-10.71,13.73,21.14,16.47,22.79,54.5,37.92,54.5,37.92l7.14-12.63-43.79-50.55-1.85-3.82",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "353.56px 296.777px"
    },
    id: "elb3hqqxnrv1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.25,
    y1: 285.4,
    x2: 391.89,
    y2: 241.24,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "389.57px 263.32px"
    },
    id: "ely04p73iyh4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.74,255.58s8.61-7.74,12.05-17.49",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "396.765px 246.835px"
    },
    id: "el68zd6f0gel7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.28,257.94a23.39,23.39,0,0,0,4.08-1.5",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "401.32px 257.19px"
    },
    id: "elol19dcsqfj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.88,260.17s3-.58,6.25-1.39",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "393.005px 259.475px"
    },
    id: "elggd02bpeo3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.14,207.18l-9.88,35.41,10.71,9-11.81,11.53s4.39,17.29,10.71,30.74S337.3,313.4,337.3,313.4s25.53-12.08,32.11-22.78,15.37-27.45,15.37-27.45l-7.68-7.68,11.25-6s-3.7-15.84-6-25.8a73.12,73.12,0,0,0-6-16.75Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "352.255px 260.17px"
    },
    id: "el0kdiraxy3jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.38,211.76s-.24,31.62-1.18,42.72,0,27.61,1.42,34.69,4.25,17.71,4.25,17.71,19.35-15.82,21.95-22.43,7.31-32.8,7.31-32.8l4.25-30.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "353.601px 259.32px"
    },
    id: "elydtjgmhftz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.32 206.09 334.2 250.47 353.08 238.19 368.9 255.66 372.91 219.31 336.32 206.09",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "353.555px 230.875px"
    },
    id: "el9tthq97vl2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.17,221.2,351,257.07l14.4-29.26S348.34,227.13,343.17,221.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "354.285px 239.135px"
    },
    id: "elj5t2csxf16o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,184.48a104.58,104.58,0,0,1-6.62-12.12c-2.52-5.71-2.06-8,.45-13.94s12.8-23.08,19.66-26.06a39,39,0,0,1,12.57-3.2s25.37-.68,37,11.66,11.88,33.37,9.14,38.86a17.34,17.34,0,0,1-9.83,8.68c-2.28.69-4.09,1.33-4.09,1.33s-2.76,0-4.59,0-11.43-5.48-19.89-12.57a138.58,138.58,0,0,1-11.2-10s-9.83,7.08-13.25,10.28-4.35,5.26-4.35,5.26l-1.33,5.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "360.02px 159.422px"
    },
    id: "el8k9i6q2mj2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.13,189.05s-8.46-1.37-13.26,3.2-5.26,16-.69,19.43,15,6.47,19.89,5,6.4-6.18,6.4-11-4.8-14.4-5.72-16.22S327.13,189.05,327.13,189.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "324.734px 202.794px"
    },
    id: "eloo2mqrfvx4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.05,187.8s-4.1-6.63-7.26-1,1.58,11.05,5,12.94a19.25,19.25,0,0,0,5.37,2.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "328.456px 193.242px"
    },
    id: "elp9cr1y01xg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,189.69s6-3.47,6.63,1.58-3.79,10.1-6,11.68-3.79,2.84-3.79,2.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "387.425px 197.159px"
    },
    id: "el8q0mmvisu8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.42,178.64S334.21,209,338,215.26s10.74,17.36,19.58,17.36,18.62-9.78,22.41-18.94,5.68-24,5.68-24-14.84-6-26.52-18-8.83-13.58-8.83-13.58S336.73,175.8,330.42,178.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "358.045px 195.36px"
    },
    id: "elln62y67j6vl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,206.42s5.72,4.57,10.75.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.695px 207.507px"
    },
    id: "elnqf1qlmlfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.9,213.05s7.77,7.54,17.82-.23",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.81px 214.577px"
    },
    id: "eloqphaowe3vb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,191.49a2.35,2.35,0,1,1-2.31-2.81A2.6,2.6,0,0,1,349.55,191.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "347.228px 191.03px"
    },
    id: "eln71jqfaaaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,192.93a2.36,2.36,0,1,1-2.32-2.81A2.61,2.61,0,0,1,373.1,192.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.766px 192.48px"
    },
    id: "elfs7wa14gqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,183.11s4.34-2.75,11.43-.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "347.715px 182.425px"
    },
    id: "eli05r3ld29vp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,184.25s3.2-3.2,13.26,3.43",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "373.98px 185.579px"
    },
    id: "el1dlkan17ytk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpdejzwddfd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.74,
    y: 185.18,
    width: 20.8,
    height: 13.26,
    rx: 4.13,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "348.14px 191.81px",
      transform: "rotate(3.06deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz0a8q30fh6i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.69,
    y: 186.68,
    width: 20.8,
    height: 13.26,
    rx: 4.13,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "373.09px 193.31px",
      transform: "rotate(2.86241deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 358.63,
    y1: 188.76,
    x2: 363.17,
    y2: 189.06,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "360.9px 188.91px"
    },
    id: "elutdxta1x5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.9,
    y1: 188.62,
    x2: 330.77,
    y2: 186.44,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "334.335px 187.53px"
    },
    id: "elfzanzorgy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.61,
    y1: 191.23,
    x2: 385.66,
    y2: 189.69,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "384.635px 190.46px"
    },
    id: "elifxibhh5gy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.62,272.57l-2.74-8s-2.2-7.68-4.67-11-7.13-4.39-9.06-6.86-4.39-9.33-6-11.25-4.94-.28-4.12,4.11,2.74,5.77,3.57,7.42,2.74,6,2.74,6-17.84-3-18.94-3.29-4.39-3.84-5.21-6-.55-11-3.85-8.23-1.37,8.51-.82,9.88,0,11,1.37,15.92,6,9.88,12.9,13.17,20.32,4.4,20.32,4.4l5.21,5.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "203.539px 259.358px"
    },
    id: "el3hqfkls7h55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.57,259.12S174,252.7,174,248s.32-9.08,2.76-7.94,2,1,2.69,5.35a44.54,44.54,0,0,0,2.82,9.73c.33.49,2.92,7,.65,7.14S177.57,259.12,177.57,259.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "178.922px 251.081px"
    },
    id: "elhcx88r3lglm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,259.12s-4.94-14-7.41-11.53-2.2,5.49,0,11.53,6.86,10.71,10.7,11.26l3.85.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "183.989px 259.114px"
    },
    id: "eltlnh16h8n3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.17,269.83s-6-4.94-9.88-4.94-12.9,1.37-12.9,1.37-6.31-21.14-8.23-17.57-1.38,7.14.55,12.63,4.66,10.43,9,13.17,20.32,4.4,20.32,4.4",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "199.066px 263.587px"
    },
    id: "ellqukcpjhqf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.94 276.42 228.62 270.1 214.63 283.55 221.49 289.04 234.94 276.42",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "224.785px 279.57px"
    },
    id: "elj4uqv95gb1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44,213.43s-19.59.68-24.25,2.87-5.22,5.49-5.49,6.87-8.51,74.66-8.51,74.66l-26.9-25.53L216,289s23.88,31.29,29.37,39.8,10.43,16.47,15.09,17.29,6.32,1.1,12.08-.54S285.72,331.08,286,330s12.63-70.31,12.63-70.31",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "257.315px 280.088px"
    },
    id: "elt6bzh39mh2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.06,
    y1: 305.86,
    x2: 277.72,
    y2: 307.98,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "275.89px 306.92px"
    },
    id: "elrjrbl35jloj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.19,
    y1: 297.83,
    x2: 271.81,
    y2: 304.56,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "266px 301.195px"
    },
    id: "elql20w7xzlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.69,334.14c-2.21.92-4.25,1.72-6,2.35",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "301.69px 335.315px"
    },
    id: "el9y0cygt14eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.1,315.63s-18.54,9-33.65,15.63",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "328.275px 323.445px"
    },
    id: "el469gtn5g6vq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.47,
    y1: 316.91,
    x2: 331.05,
    y2: 329.25,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "342.76px 323.08px"
    },
    id: "el759cq5pidnj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-33",
    className: "animable",
    style: {
      transformOrigin: "433.182px 316.165px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.19,340.35h30.62s4.43,0,2.82,6.85-8.06,44.31-8.87,58.41-1.61,22.56-1.61,22.56H452.34l14.33-82.61a6.75,6.75,0,0,1,6.67-5.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "517.161px 384.07px"
    },
    id: "elh4z4493u60w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.51,286.71s-34.78,9.74-35.34,13.08-15.3,84.87-15.3,84.87S329,365.74,324.79,365.74s-20.32,13.63-22.54,15.3-5.29,3.07-5.57,6.4-3.06,8.63,0,11.13,5,4.74,6.12,3.34-.27-6.12-.55-7,17.53-10,17.53-10l7.23-1.67a54,54,0,0,1-8.35,6.12c-4.73,2.78-6.39,7.52-3.89,7.79s2.78-.83,10-3.06,13.35-9.46,13.35-9.46,70.4,32.84,74.3,32.84,3.34.83,6.68-3.62,14.19-36.17,14.19-36.17l4.17,41.18v9.19H546.84s-.56-118.55-1.11-120.22-43.26-28.58-43.26-28.58Z",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "421.048px 353.65px"
    },
    id: "elbzca4kvhgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.99,
    y1: 364.5,
    x2: 420.58,
    y2: 361.41,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "421.785px 362.955px"
    },
    id: "elrxxu6zkkjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.31,
    y1: 377.71,
    x2: 425.11,
    y2: 367.22,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "429.21px 372.465px"
    },
    id: "elkfe8cm454hk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.81,
    y1: 343.74,
    x2: 421.55,
    y2: 339.69,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "422.18px 341.715px"
    },
    id: "elfz3buxb8k8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "427.74 340.35 433.31 377.7 424.11 347.96",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "428.71px 359.025px"
    },
    id: "elbjjiqzh1rx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.28,284.87l-8.81-5.59-50,7.43,23.37,50.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "481.875px 308.18px"
    },
    id: "el8gcni4zm2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,212.36c-6.65,4.58-16.13,14.6-14,21,2.24,6.72,5.6,8.21,5.6,8.21s-3,9.33-.37,12.32a21.84,21.84,0,0,1,3.73,6s-5.6,15.68-3,17.55l2.61,1.86s4.48,17.92,7.84,19,13.44-1.87,13.44-1.87L476,323.7l26.51-44.42-2.62-9s15.68-25.75,9.34-44c-3.65-10.51-13.11-17.77-23.55-20.82-11.53-3.36-21.49.34-32.21,4.93A20.69,20.69,0,0,0,450,212.36Z",
    style: {
      fill: "rgb(194, 194, 194)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "473.217px 263.931px"
    },
    id: "el60ctworf0y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.19,226.28c-3.65-10.51-13.11-17.77-23.55-20.82-11.53-3.36-21.49.34-32.21,4.93a20.69,20.69,0,0,0-3.41,2c-6.65,4.58-16.13,14.6-14,21,2.24,6.72,5.6,8.21,5.6,8.21a7.93,7.93,0,0,0,6.44-2.17c2.78-2.78,10-7.79,15.86-7s5.84,7.79,3.89,11.13-2.5,7.24,2.51,8.35,6.4,1.11,6.4,5-.28,7,2.78,6.4,3.34-1.95,4.73-5,7.51-7.79,10.85,1.67-3.34,13.91-3.34,13.91a46.29,46.29,0,0,0,8.37-4C502.1,266.47,515.05,243.19,509.19,226.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "473.207px 239.025px"
    },
    id: "elcbqovos4gc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.33,258.33s8.07-3.62,13.36,0",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "455.01px 257.526px"
    },
    id: "elop1tpqte1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.06,283.37s8.62,3.34,14.19-2.78",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "455.155px 282.435px"
    },
    id: "elq7p52yxr0us",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.61,
    y1: 279.28,
    x2: 449.17,
    y2: 280.04,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "446.89px 279.66px"
    },
    id: "eljm7ntchkb8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.35,264.65c0,1.57-.87,2.85-2,2.85s-1.95-1.28-1.95-2.85.87-2.84,1.95-2.84S458.35,263.08,458.35,264.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "456.375px 264.655px"
    },
    id: "el8smc8464iwv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.89,296.45s10-3.89,12.78-5.84,4.45-3.34,4.45-3.34l-13.64,18.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "474.505px 296.315px"
    },
    id: "el8r8fan6bgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.47,371.35c-12.74-3.15-23.18-5.61-24.68-5.61-4.18,0-20.32,13.63-22.54,15.3s-5.29,3.07-5.57,6.4-3.06,8.63,0,11.13,5,4.74,6.12,3.34-.27-6.12-.55-7,17.53-10,17.53-10l7.23-1.67a54,54,0,0,1-8.35,6.12c-4.73,2.78-6.39,7.52-3.89,7.79s2.78-.83,10-3.06,13.35-9.46,13.35-9.46,3.25,1.52,8.38,3.89A22.32,22.32,0,0,0,349.47,371.35Z",
    style: {
      fill: "rgb(194, 194, 194)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "322.656px 384.041px"
    },
    id: "elumqantzlbth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.14,
    y1: 384.66,
    x2: 341.2,
    y2: 377.43,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "339.67px 381.045px"
    },
    id: "elhjadoyirw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,381.6s-13.63,8.63-16.14,10.3-11.13,3.61-10.29,5.28,2.78,2.51,6.68,1.39a100.1,100.1,0,0,0,13.08-4.17c4.45-1.95,15.58-9.46,15.58-9.46",
    style: {
      fill: "rgb(194, 194, 194)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "302.081px 390.34px"
    },
    id: "elbh897xgs53",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.93,299s18.92,8.35,21.42,13.08,7.52,108,7.79,111a4.1,4.1,0,0,1-3.61,4.45c-1.39.28-90.16-.27-92.66-.27s-8.63-.56-12.25-2.23-6.4-1.11-6.68-5.57a86.13,86.13,0,0,1,.28-9.73c0-1.67-1.11-6.4,0-9.19s3.34-2.78,4.45-3.06a32.53,32.53,0,0,1,5.29,0,6.81,6.81,0,0,1,7-.83c4.17,1.67,11.13,11.68,11.13,11.68s6.68,1.95,17.25.28,34.5-6.68,34.5-6.68l-9.46-59.27",
    style: {
      fill: "rgb(44, 157, 202)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "504.442px 363.305px"
    },
    id: "elqkydx5shfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.8,
    y1: 401.91,
    x2: 528.2,
    y2: 411.93,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "527.5px 406.92px"
    },
    id: "el8x8xqr6c6qj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.44,427.32c-2.92-9.67-.59-15.2,1.72-18.06a33.78,33.78,0,0,1-8.11-.95s-7-10-11.13-11.68a6.81,6.81,0,0,0-7,.83,32.53,32.53,0,0,0-5.29,0c-1.11.28-3.34.28-4.45,3.06s0,7.52,0,9.19a86.13,86.13,0,0,0-.28,9.73c.28,4.46,3.06,3.9,6.68,5.57s9.74,2.23,12.25,2.23Z",
    style: {
      fill: "rgb(194, 194, 194)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "464.923px 411.671px"
    },
    id: "els4spoyea2p",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-33",
    className: "animable",
    style: {
      transformOrigin: "284.295px 384.06px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "315.6 422.91 198.3 422.91 178.12 339.95 295.41 339.95 315.6 422.91",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "246.86px 381.43px"
    },
    id: "elx15ond4psic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.85,383c0,2.57-7.58,4.65-16.92,4.65S227,385.59,227,383s7.57-4.64,16.92-4.64S260.85,380.46,260.85,383Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "243.925px 383.005px"
    },
    id: "eljykop48mq1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.3,
    y: 422.91,
    width: 192.17,
    height: 5.26,
    style: {
      fill: "rgb(194, 194, 194)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "294.385px 425.54px"
    },
    id: "elh8re08scvb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.24,
    y: 422.91,
    width: 73.23,
    height: 5.26,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "353.855px 425.54px"
    },
    id: "el0n2siuny0zaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.92,
    y: 424.41,
    width: 6.34,
    height: 1.15,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "326.09px 424.985px"
    },
    id: "elzv9tshd0n1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.05,
    y: 424.41,
    width: 6.34,
    height: 1.15,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "342.22px 424.985px"
    },
    id: "elui7bi3gpofe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-33",
    className: "animable",
    style: {
      transformOrigin: "356.65px 428.17px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 649.95,
    y1: 428.17,
    x2: 63.35,
    y2: 428.17,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "356.65px 428.17px"
    },
    id: "elt4z2p3texcd",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedAssistance);
export default __webpack_public_path__ + "static/media/needAssistance.78b4bb876e1f51435d34062d0697d90d.svg";
export { ForwardRef as ReactComponent };